import { gsap } from 'gsap';

export class TextMediaScrollHijack {
  constructor() {
    this.selector = 'b-af-text-media-scroll-hijack';

    this.blocks = Array.from(document.querySelectorAll(`.${this.selector}`));

    if (this.blocks.length === 0) {
      return;
    }

    this.classNames = {
      active: 'active',
      body: 'b-af-text-media-scroll-hijack__body',
      item: 'b-af-text-media-scroll-hijack__item',
      itemContent: 'b-af-text-media-scroll-hijack__col-content',
      itemInViewport: 'in-viewport',

      items: 'b-af-text-media-scroll-hijack__items',
      media: 'b-af-text-media-scroll-hijack__col-media',
      mediaItem: 'b-af-text-media-scroll-hijack__medias-item-media',
      mediaItems: 'b-af-text-media-scroll-hijack__medias-items',

      mediaItemsSticky: 'b-af-text-media-scroll-hijack__media-items',

      videoElement: 'afp-video-file',
    };

    this.ANIMATION_DURATION = 0.3;

    this.initialize();
  }

  initialize() {
    this.initBlocks({ blocks: this.blocks });
  }

  initBlocks({ blocks }) {
    blocks.forEach((block) => {
      // First do the indexes
      this.handleIndexes({ block });
      // Rearrange the content

      this.handleBlockItemsScroll({ block });
    });
  }

  handleIndexes({ block }) {
    const items = Array.from(block.querySelectorAll(`.${this.classNames.item}`));
    const mediaItems = Array.from(block.querySelectorAll(`.${this.classNames.mediaItem}`));

    if (items.length === 0) {
      return;
    }

    items.forEach((item, index) => {
      const itemContent = item.querySelector(`.${this.classNames.itemContent}`);

      itemContent.setAttribute('data-source', index);
    });

    if (mediaItems.length === 0) {
      return;
    }

    mediaItems.forEach((item, index) => {
      item.setAttribute('data-target', index);
    });
  }

  showActiveMediaItemByVisibleItem({ item }) {
    if (!item) {
      return;
    }

    const block = item.closest(`.${this.selector}`);

    if (!block) {
      return;
    }

    const mediaItem = block.querySelector(
      `.${this.classNames.mediaItem}[data-target="${item.dataset.source}"]`
    );

    const mediaItems = block.querySelectorAll(`.${this.classNames.mediaItem}`);

    if (!mediaItem) {
      return;
    }

    mediaItems.forEach((media) => {
      gsap.to(media, { duration: this.ANIMATION_DURATION, opacity: 0 });
    });

    gsap.to(mediaItem, {
      duration: this.ANIMATION_DURATION,
      opacity: 1,
    });
  }

  getVisibleSection({ sections }) {
    let currentSection = sections[0];
    let largestVisibleArea = 0;

    sections.forEach((section) => {
      const rect = section.getBoundingClientRect();

      if (rect.top < window.innerHeight && rect.bottom > 0) {
        const visibleHeight = Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0);

        if (visibleHeight > largestVisibleArea) {
          largestVisibleArea = visibleHeight;
          currentSection = section;
        }
      }
    });

    return currentSection;
  }

  hideAllMediaItems({ block }) {
    const mediaItems = block.querySelectorAll(`.${this.classNames.mediaItem}`);
    mediaItems.forEach((media) => {
      gsap.to(media, { duration: this.ANIMATION_DURATION, opacity: 0 });
    });
  }

  handleBlockItemsScroll({ block }) {
    const blockContentItems = Array.from(block.querySelectorAll(`.${this.classNames.itemContent}`));

    window.addEventListener('scroll', () => {
      const visibleSection = this.getVisibleSection({ sections: blockContentItems });

      if (!visibleSection) {
        this.hideAllMediaItems({ block });
        return;
      }

      blockContentItems.forEach((item) => {
        if (item === visibleSection) {
          if (!item.classList.contains(this.classNames.itemInViewport)) {
            this.showActiveMediaItemByVisibleItem({ item });
            item.classList.add(this.classNames.itemInViewport);
          }
        } else {
          item.classList.remove(this.classNames.itemInViewport);
        }
      });
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/blocks/textMediaScrollHijack.js